module.exports = __webpack_public_path__ + "img/add_icon.92cf7642.png";